import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRightLongToLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M38 10.55V29.45C38 30.1981 37.3981 30.8 36.65 30.8C35.9019 30.8 35.3 30.1981 35.3 29.45V10.55C35.3 9.80189 35.9019 9.20001 36.65 9.20001C37.3981 9.20001 38 9.80189 38 10.55ZM30.4062 19.0438C30.935 19.5725 30.935 20.4275 30.4062 20.9506L22.7563 28.6063C22.2275 29.135 21.3725 29.135 20.8494 28.6063C20.3263 28.0775 20.3206 27.2225 20.8494 26.6994L26.1931 21.3556L3.35 21.35C2.60187 21.35 2 20.7481 2 20C2 19.2519 2.60187 18.65 3.35 18.65H26.1931L20.8494 13.3063C20.3206 12.7775 20.3206 11.9225 20.8494 11.3994C21.3781 10.8763 22.2331 10.8706 22.7563 11.3994L30.4062 19.0438Z" })
});
export default SvgArrowRightLongToLine;
